import { TemplatePage } from './types';

const quotesPage: TemplatePage = {
  header: {
    color: '#FED7EC',
    icon: 'images/video-templates/quotes.jpg',
    title: 'Video Quote Templates Collection',
    title_meta: '200+ Video Quote Templates - Editable and Free',
    description_meta:
      'Get your audience motivated and inspired with Wave.video’s collection of 200+ beautiful video quote templates.',
    description:
      'Get your audience motivated and inspired with this collection of 200+ beautiful video quote templates. Pick ' +
      'a template and share it on social to make your message stand out.'
  },
  footer: {
    category: 'quotes',
    description:
      'Wave.video’s diverse collection of beautiful video quote templates helps create engaging videos for your blog, ' +
      'website, email newsletter, or social media in a matter of minutes. All the templates are easy and free to ' +
      'personalize to suit your brand and message.'
  },
  content: [
    {
      type: 'templates',
      title: 'Video Quote',
      search: { category: '/Use Cases/Quote Videos' }
    },
    {
      type: 'stocks',
      title: 'quotes',
      search: { name: 'quotes' }
    },
    { type: 'calendar' }
  ]
};

export default quotesPage;
